import { applyMiddleware, createStore, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { reduxBatch } from '@manaflair/redux-batch'
import { composeWithDevTools } from '@redux-devtools/extension'
import reducers from './reducers'
import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware({
  onError (error) {
    console.error('[redux-saga] Uncaught saga error (sibling sagas keep running if spawned):', error)
  }
})
const bindMiddlewares = middleware => {
  const applyResult = compose(...middleware)

  if (import.meta.env.DEV) {
    return composeWithDevTools(applyResult)
  }

  return applyResult
}

export function configureStore (initialState = {}) {
  const store = createStore(
    reducers(),
    initialState,
    bindMiddlewares([
      reduxBatch,
      applyMiddleware(sagaMiddleware),
      reduxBatch
    ])
  )

  sagaMiddleware.run(rootSaga)

  return store
}

const store = configureStore()

export default store
